import { render, staticRenderFns } from "./UserPermissionForm.vue?vue&type=template&id=a107fb28&"
import script from "./UserPermissionForm.vue?vue&type=script&lang=js&"
export * from "./UserPermissionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports